import { Component, OnInit, OnDestroy } from '@angular/core';
import { MessageService, ConfirmationService } from 'primeng/api';
import { GiftCardOrderSalesModel} from "src/app/models/gifcardVirtual.model";
import { saveAs } from 'file-saver';
import { ExcelService } from 'src/app/services/excel.service';
import { AuthService } from 'src/app/services/auth.service';
import { EmailSendModel, EmailTemplateModel } from 'src/app/models/email.model';
import { GiftCardTiendaItemModel } from 'src/app/models/gifcardVirtual.model';
import { timer } from 'rxjs';
import { Subscription } from 'rxjs';
import { TraceService } from 'src/app/services/trace.service';
import { TraceModel } from 'src/app/models/trace.model';
import { GifcardTiendaService } from 'src/app/services/giftcardTienda.service';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';

@Component({
    selector: 'app-ordersales-tienda-list',
    templateUrl: './ordersales-tienda-list.component.html',
    styleUrls: ['./ordersales-tienda-list.component.css']
})
export class OrdersalesTiendaListComponent implements OnInit, OnDestroy {
    constructor(private giftcardTiendaService: GifcardTiendaService,
        private giftcardService: GifcardVirtualService,
        private messageService: MessageService,
        private excelService: ExcelService,
        private authService: AuthService,
        private confirmationService: ConfirmationService,
        private traceService: TraceService) { }

    private subscription: Subscription = new Subscription();
    totalOrderSales: number;
    dlgOrderSales: boolean;
    dlgEmailFails: boolean;
    dlgUpdateEmail: boolean;
    itemOrderSales;
    itemSendFails;
    selectOrderSales: GiftCardOrderSalesModel;
    datasourceTablaOrderSales: GiftCardOrderSalesModel[] = [];
    colsTablaOrderSales: any[];
    colsTablaEmailFails: any[];
    colsTablaTrace: any[];
    dataDetail: {};
    datasourceTiendaItemModel: GiftCardTiendaItemModel [] = [];
    datasourceEmailFails: EmailSendModel[] = [];
    datasourceTrace: TraceModel[] = [];
    loading: boolean = false;
    currentUser: string;

    id_emailsend: number;
    email_sender: string;
    email_recipient: string;
    email_subject: string;
    email_bodyhtml: string;
    email_path_file: string;
    email_name_client: string;
    email_contacto: string;
    email_endpoint: string;
    emailValidateLast: string;
    sendMasivo: string;
    datasourceEmailTemplate: EmailTemplateModel[];

    ngOnInit() {
        this.currentUser = this.authService.getCurrentUser();
        this.createColumnsTablaGiftCardVirtual();
        this.createColumnsTablaEmailFails();
        this.createColumnsTableTrace();
        this.refreshData();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    refreshData() {
        this.subscription.add(this.populateTableOrderSales());
        this.subscription.add(this.subscribeToData());
    }

    subscribeToData() {
        this.subscription.add(console.log("refreshdata"));
        this.subscription.add(
            timer(60000).subscribe(() => this.refreshData())
        );
    }

    createColumnsTablaGiftCardVirtual() {
        this.colsTablaOrderSales = [
            { field: 'NRORUC_CLIENTE', header: 'RUC', width: '10%', align: 'center' },
            { field: 'RAZSOC_CLIENTE', header: 'Razón Social', width: '50%', align: 'center' },
            { field: 'NRO_ORDEN_COMPRA', header: 'Nro. Ord. Compra', width: '10%', align: 'center' },
            { field: 'IMP_ORDEN_COMPRA', header: 'Importe', width: '10%', align: 'center' }
        ];
    }

    createColumnsTableTrace() {
        this.colsTablaTrace = [
            { field: 'ACTION', header: 'Acción', width: '10%', align: 'center' },
            { field: 'OBSERVATION', header: 'Observaciones', width: '60%', align: 'center' },
            { field: 'CREATIONUSER', header: 'Usuario', width: '10%', align: 'center' },
            { field: 'CREATIONDATE', header: 'Fecha Acción', width: '20%', align: 'center' }
        ];
    }

    createColumnsTablaEmailFails() {
        this.colsTablaEmailFails = [
            { field: 'ID_EMAILSEND', header: 'ID', width: '5%', align: 'center' },
            { field: 'NAME_FILE', header: 'Nombre Archivo', width: '15%', align: 'center' },
            { field: 'EMAIL_SEND', header: 'Correo', width: '15%', align: 'center' },
            { field: 'NAME_SEND', header: 'Enviado a', width: '15%', align: 'center' },
            { field: 'MESSAGE_SEND', header: 'Mensaje', width: '30%', align: 'center' },
            { field: 'STATUS_TEXT', header: 'Estado', width: '10%', align: 'center' }
        ];
    }

    populateTableOrderSales() {
        this.loading = true;
        this.giftcardTiendaService.GetGiftCardOrderSalesTienda().subscribe(
            (response: GiftCardOrderSalesModel[]) => {
                this.datasourceTablaOrderSales = response;
                this.totalOrderSales = this.datasourceTablaOrderSales.length;
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar las ordenes de compra.' });
            }
        )
    }

    populateOrderSalesTrace(order) {
        let params = {
            "p_id_order_gift_card": order.ID_ORDER_SALES,
            "p_type_order_sales": this.giftcardTiendaService.TYPE_ORDER_SALES_TIENDA
        };
        this.traceService.GetOrderSalesTraceByOrder(params).subscribe(
            (response: TraceModel[]) => {
                this.datasourceTrace = response;
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar trace de la orden de compra.' });
            }
        )
    }

    onShowConfirmAnulate(order: GiftCardOrderSalesModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro de anular la orden de compra?',
            accept: () => {
                this.anulateOrderSalesStatus(order);
            }
        });
    }

    anulateOrderSalesStatus(order: GiftCardOrderSalesModel) {
        this.loading = true;
        let params = {
            "p_id_order_gift_card": order.ID_ORDER_SALES,
            "p_id_modelo_gift_card": order.ID_MODELO_GIFT_CARD,
            "p_id_cliente_gift_card": order.ID_CLIENTE,
            "p_id_contact_gift_card": order.ID_CONTACT,
            "p_flg_activo": 0
        }
        this.giftcardTiendaService.UpdateOrderSalesTiendaStatus(params).subscribe(
            (response) => {
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Anulación paso 1: exitoso.' });
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al anular orden de compra.' });
            }
        )
    }

    exportAsXLSX(order: GiftCardOrderSalesModel): void {
        this.itemOrderSales = order;
        this.populateSkusTienda();
    }

    populateSkusTienda() {
        this.loading = true;
        let params = {
            "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
            "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
            "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT
        }
        this.giftcardService.GetGiftCardOrderSalesTiendaItems(params).subscribe(
            (response) => {
                this.datasourceTiendaItemModel = response;
                this.excelService.exportAsExcelFile(this.datasourceTiendaItemModel, 'sku');
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al anular orden de compra.' });
            }
        )
    }

    onShowDlgOrderSales(order: GiftCardOrderSalesModel) {
        this.itemOrderSales = order;
        this.dlgOrderSales = true;
        this.populateOrderSalesTrace(order);
    }

    downloadIMGModel() {
        saveAs(this.itemOrderSales.IMG_MODELO_GIFT_CARD, "modelo.jpg");
    }

    downloadIMGOrder() {
        saveAs(this.itemOrderSales.IMG_ORDEN_COMPRA, "orden.jpg");
    }

    downloadIMGCotizacion() {
        saveAs(this.itemOrderSales.IMG_COTIZACION, "cotizacion.jpg");
    }

    donwloadAdicional1() {
        saveAs(this.itemOrderSales.IMG_ADICIONAL1, "adicional.jpg");
    }

    donwloadAdicional2() {
        saveAs(this.itemOrderSales.IMG_ADICIONAL2, "adiciona2.jpg");
    }

    donwloadAdicional3() {
        saveAs(this.itemOrderSales.IMG_ADICIONAL3, "adiciona3.jpg");
    }

    donwloadLiquidacion() {
        saveAs(this.itemOrderSales.IMG_LIQUIDACION, "liquidacion.jpg");
    }

    donwloadConstancia() {
        saveAs(this.itemOrderSales.IMG_CONSTANCIA, "constanciajpg");
    }

    donwloadGuia() {
        saveAs(this.itemOrderSales.IMG_GUIA, "guia.jpg");
    }
}